import React from 'react';
import ButtonCreate from '../../components/actions/ButtonCreate';
import ButtonUser from '../../components/actions/ButtonUser';
import BaseMenu from '../../components/navigation/BaseMenu';
import { UserMenu } from '../../components/user-menu';
import { InfoMenu } from '../../components/info-menu';
import { Variant } from '../types';

const variant: Variant = {
  getMenuItems: (experiment): JSX.Element[] => {
    return [<BaseMenu key="base-menu" experiment={experiment} />];
  },
  actions: [
    <ButtonUser key="action-user" />,
    <ButtonCreate key="action-create" />,
  ],
  info: [<InfoMenu key="menu-info" />],
  user: [<UserMenu key="menu-user" />],
  homePage: '/',
};

export default variant;
